const isHighRes = () => {
  if (window.matchMedia) {
    const mq = window.matchMedia('only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)');
    return ((mq && mq.matches) || (window.devicePixelRatio > 1));
  }
  return false;
};

const psJSON = (data) => JSON.parse(JSON.stringify(data));

const isIOS = () => {
  const iosQuirkPresent = function () {
    const audio = new Audio();
    audio.volume = 0.5;
    return audio.volume === 1; // volume cannot be changed from "1" on iOS 12 and below
  };

  const isItIOS = /iPad|iPhone|iPod/.test(navigator.userAgent);
  const isAppleDevice = navigator.userAgent.includes('Macintosh');
  const isTouchScreen = navigator.maxTouchPoints >= 1; // true for iOS 13 (and hopefully beyond)

  return isItIOS || (isAppleDevice && (isTouchScreen || iosQuirkPresent()));
};

export {
  isHighRes,
  psJSON,
  isIOS,
};
